import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormControl, FormControlProps, InputGroup, Tooltip } from '@chakra-ui/react';

type AttachImageButtonProps = FormControlProps & {
  onUpload: (files: FileList | null) => void;
  isLoading: boolean;
  isCrossLangReview: boolean;
  isImageHelperTextDisplayed?: boolean;
};

export const AttachImageButton: React.FC<AttachImageButtonProps> = ({
  onUpload,
  isLoading,
  isCrossLangReview,
  isImageHelperTextDisplayed = true,
  ...rest
}) => {
  const { t } = useTranslation();
  const shouldDisplayTooltip = isCrossLangReview && isImageHelperTextDisplayed;
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <FormControl w="max-content" {...rest}>
      <InputGroup
        onClick={() => {
          fileInputRef.current?.click();
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,.pdf"
          onChange={(e) => onUpload(e.target.files)}
          multiple
          hidden
        />
        {shouldDisplayTooltip ? (
          <Tooltip
            textAlign="center"
            label={t('projectReviews.projectReview.crossLangImageHelper')}
            hasArrow
            shouldWrapChildren
          >
            <Button variant="link" isDisabled={isLoading}>
              {t('projectReviews.attachImage')}
            </Button>
          </Tooltip>
        ) : (
          <Button variant="link" isDisabled={isLoading}>
            {t('projectReviews.attachImage')}
          </Button>
        )}
      </InputGroup>
    </FormControl>
  );
};
